module.exports = __webpack_public_path__ + "img/snapchat.8c9a9dce.svg";